import React from "react";
import { makeStyles } from "tss-react/mui";
import { SquareIconButton, OutlinedButton } from "../../../button/Buttons.js";
import "../../../button/EditButton.js";
import { LocalizedText } from "../../../i18n/LocalizedText.js";
import { Icon } from "../../../icons/Icon.js";
import { CustomIcon } from "../../../icons/types.js";
import "../../../icons/ExpandMoreIcon.js";
import "@mui/material";
import { StyledTooltip } from "../../../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../../../label/EmptyLabel.js";
import "../../../label/LabelHoc.js";
import "../../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const useStyles = makeStyles()((theme) => ({
  buttonCell: {
    minWidth: "unset",
    height: "32px"
  },
  buttonCellLinkType: {
    color: theme.palette.primary.main,
    cursor: "pointer"
  }
}));
function ButtonCell({ value, onClick }) {
  const { type = "button", icon, label, disabled, disableTooltip } = value;
  const { cx, classes } = useStyles();
  const mapper = {
    button: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      OutlinedButton,
      {
        startIcon: icon ? /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon[icon?.key], color: icon.color }) : null,
        label,
        onClick,
        className: classes.buttonCell,
        disabled
      }
    )),
    icon: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SquareIconButton, { onClick, iconClassName: CustomIcon[icon?.key], iconFontSize: 16, disabled })),
    link: /* @__PURE__ */ React.createElement("div", { className: cx(!disabled && classes.buttonCellLinkType), onClick: () => !disabled ? onClick() : null }, /* @__PURE__ */ React.createElement(LocalizedText, { label }))
  };
  const component = mapper[type];
  return disableTooltip ? component : /* @__PURE__ */ React.createElement(StyledTooltip, { hideTooltip: disableTooltip, title: /* @__PURE__ */ React.createElement(LocalizedText, { label }), element: component });
}
export {
  ButtonCell
};
//# sourceMappingURL=ButtonCell.js.map
